import { MINICART_CROSS_SELL_PRODUCT_LIST_NAME } from 'src/components/cart/CartFeedback/constants'

export const getProductListName = ({
  isMiniCartCrossSell,
  isPLP,
  currentPageType,
  title = '',
}: {
  isMiniCartCrossSell: boolean
  isPLP: boolean
  currentPageType?: string
  title?: string
}) => {
  if (isMiniCartCrossSell) {
    return MINICART_CROSS_SELL_PRODUCT_LIST_NAME
  }

  if (isPLP) {
    return `${currentPageType} : ${title}`
  }

  return `Vitrine: ${title}`
}
